import React, { useEffect, useState } from "react";
import { Upload, Card, Row, Col, Button, message } from "antd";
import { InboxOutlined, SendOutlined } from "@ant-design/icons";
import { API_URL, host } from "../../constants";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";

const { Dragger } = Upload;

// TODO: Fetch from backend
const bankTypes = [
  {
    slug: "VB",
    name: "BC VictoriaBank S.A."
  },
  {
    slug: "MICB",
    name: "BC MoldIndConBank S.A."
  },
  {
    slug: "POSTA",
    name: "C.P. Chisinau"
  },
  {
    slug: "MAIB",
    name: "BC Moldova-Agroindbank S.A."
  },
  {
    slug: "FINCOMBANK",
    name: "Banca de Finante si Comert S.A."
  }
];

const Banks = () => {
  const [bankType, setBankType] = useState("");
  const [errorBanks, setErrorBanks] = useState(null);
  const [dates, setDates] = useState(null);
  const [blockedButtons, setBlockedButtons] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const { accessToken } = useSelector((s) => s.user.currentUser);
  const [intervalId, setIntervalId] = useState(null);
  // const [fileList, setFileList] = useState({
  //   VB: [],
  //   MICB: [],
  //   MAIB: [],
  //   POSTA: [],
  //   FINCOMBANK: [],
  // });
  const [fileList, setFileList] = useState(null);

  useEffect(() => {
    const initValues = {};
    bankTypes.forEach((bank) => {
      initValues[bank.slug] = [];
    });

    setFileList(initValues);
  }, []);

  // poll backend for parsing progress
  const checkStatus = async () => {
    if (!bankType) return;
    console.log({ bankType });
    try {
      const res = await axios.get(
        `${API_URL}user/gestionar/bankParser/${bankType}`
      );
      console.log({ res });
      const data = res.data.parsing;
      const results = res.data.results;

      if (results?.failed > 0) {
        messageApi.error(
          `Failed ${results.failed} rows. Created (${results.created}) and updated (${results.updated}) rows will not be added until all errors are resolved`
        );
      } else if (results?.created || results?.updated) {
        messageApi.success(
          `Created (${results.created}) rows and updated (${results.updated}) rows.`
        );
      }

      const errors = res.data.error;
      // const dates = Object.keys(res.data).filter(
      //   (item) => res.data[item].lastModified
      // );

      // const dateMapper = {};
      // dates.forEach((date) => {
      //   dateMapper[date] = [
      //     {
      //       key: date,
      //       label: moment(res.data[date].lastModified).format(
      //         "DD-MM-YYYY, HH:mm"
      //       ),
      //     },
      //   ];
      // });
      // setDates(dateMapper);

      if (errors) {
        setErrorBanks(errors);
      } else {
        setErrorBanks(null);
      }

      if (!data) {
        clearInterval(intervalId);
        setBankType("");
      }

      // setBlockedButtons(() =>
      //   data.map((item) => {
      //     return { ...res.data[item], name: item };
      //   })
      // );
    } catch (error) {
      console.error(error);
    }
  };

  // const getTest = async () => {
  //   try {
  //     const res = await axios.get(`${API_URL}user/test`);
  //     console.log({ res });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   getTest();
  // }, []);

  useEffect(() => {
    if (bankType) {
      const id = setInterval(checkStatus, 2000);
      setIntervalId(id);
      return () => clearInterval(id);
    }
  }, [bankType]);

  // handle file upload (with bank type)
  const handleUpload = (info, bank) => {
    if (info.file.status === "done") {
      const { accepted, rejected } = info.file.response;

      if (accepted.length) {
        messageApi.success(`${accepted[0].filename} încărcat cu succes`);
        setFileList((prev) => ({
          ...prev,
          [bank]: info.fileList
        }));
      }
      if (rejected.length) {
        rejected.forEach((file) => {
          messageApi.error(`Fișier respins: ${file.filename}. ${file.message}`);
        });

        // Remove rejected files from the list after 2 seconds
        setTimeout(() => {
          setFileList((prev) => ({
            ...prev,
            [bank]: prev[bank].filter((f) => f.uid !== info.file.uid),
          }));
        }, 2000);
      }
    }
    else if (info.file.status === "error") {
      messageApi.error(`${info.file.name} încărcarea a eșuat.`);

      // Remove failed files from the list after 2 seconds
      setTimeout(() => {
        setFileList((prev) => ({
          ...prev,
          [bank]: prev[bank].filter((f) => f.uid !== info.file.uid),
        }));
      }, 2000);
    }
    else if (info.file.status === "uploading") {
      setFileList((prev) => ({
        ...prev,
        [bank]: info.fileList,
      }));
    }
  };

  const handleSend = async (bank) => {
    try {
      const res = await axios.get(
        `${API_URL}user/gestionar/startParseBanks/${bank}`,
        {
          headers: { Authorization: "Bearer " + accessToken },
        }
      );
      console.log({ data: res.data });
      setBankType(bank);

      setFileList((prev) => ({
        ...prev,
        [bank]: []
      }));
      messageApi.success('Fisierul a fost procesat cu succes');
    } catch (error) {
      console.error(error);
      messageApi.error("Eroare la pornirea parserului");
    }
  };

  const renderUploader = (slug, name) => (
    <Card
      title={`${slug} - ${name}`}
      bordered={false}
      style={{ borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
      actions={[
        <Button
          type="primary"
          icon={<SendOutlined />}
          onClick={() => handleSend(slug)}
          disabled={fileList[slug].length === 0 || fileList[slug].filter((f) => f.status !== "done").length}
        >
          Trimite
        </Button>,
      ]}
    >
      <Dragger
        multiple={false}
        onChange={(info) => handleUpload(info, slug)}
        onRemove={(file) => {
          setFileList((prev) => ({
            ...prev,
            [slug]: prev[slug].filter((f) => f.uid !== file.uid),
          }));
        }}
        fileList={fileList[slug]}
        action={`${host}/banca/upload?bank=${slug}`}
        name="files"
        style={{ padding: "16px" }}
        disabled={fileList[slug].filter((f) => f.status === "done").length > 0}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Faceți clic sau trageți fișierul în această zonă pentru a-l încărca
        </p>
        <p className="ant-upload-hint">
          Doar fișiere .txt corespunzătoare acestui bank.
        </p>
      </Dragger>
    </Card>
  );

  const renderItems = () => {
    if (!fileList) return null;

    return Object.keys(fileList).map((bankSlug) => {
      const item = bankTypes.find((item) => item.slug === bankSlug);

      if (!item) return null;

      const { slug, name } = item;

      return (
        <Col key={slug} xs={24} sm={12} lg={12}>
          {renderUploader(slug, name)}
        </Col>
      );
    });
  };

  return (
    <div style={{ padding: "24px" }}>
      {contextHolder}
      <Row gutter={[24, 24]}>
        {renderItems()}
      </Row>
    </div>
  );
};

export default Banks;
